var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 81,
    viewBox: "0 0 114 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_3557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0859 31.7869C64.5048 31.0337 68.634 28.5134 67.2576 20.692C66.1966 15.6225 60.9778 16.086 59.0279 19.9098C56.103 26.196 58.1389 26.8622 55.8736 29.7012C53.8663 31.6131 52.1458 23.5019 48.5901 29.0349C47.6725 30.6861 49.0202 32.627 48.0166 34.394C45.7226 35.6686 43.3999 32.3662 40.9338 32.1635C37.8656 31.2944 34.0231 33.3801 34.2239 36.7694C34.74 42.65 40.3603 42.679 44.1168 45.8655C45.7513 47.5747 46.4395 49.9211 46.7836 52.2675C50.2533 63.4493 59.9741 50.4715 62.0101 49.7183C65.3651 48.0092 67.487 52.9338 70.9854 52.4703C74.9712 52.6731 76.7204 48.4727 75.6308 45.4889C74.9139 42.5921 70.1825 40.9409 71.6449 39.2897C72.878 38.073 74.7705 38.1889 76.0609 36.8274C77.4086 35.5238 77.38 32.8008 75.0859 31.7869Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7847 25.8783C70.9567 22.5759 75.258 17.854 79.1291 18.6941C83.8892 20.664 72.2758 28.6882 70.7847 25.8783ZM72.5052 24.2271C72.7919 23.4739 73.2794 22.7207 73.5948 22.2862C73.1551 22.8269 72.7919 23.4353 72.5052 24.1112C72.5052 24.1498 72.5052 24.1885 72.5052 24.2271Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8157 18.317C52.0023 19.1861 57.4506 25.5302 47.0988 23.2706C43.1417 22.4595 42.8262 17.6508 47.8157 18.317ZM46.2099 21.098C45.7224 20.8083 45.7798 20.3159 45.8084 20.171C46.1334 20.0165 46.4584 19.9103 46.7834 19.8524C46.7643 19.8524 46.7356 19.8524 46.6974 19.8524C45.493 19.7655 45.5504 20.7504 46.2099 21.098Z",
    fill: "#38C1ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0378 55.2813C33.5645 55.2234 36.8908 48.0682 40.9053 48.1551C42.7118 48.271 40.0164 55.1365 38.0378 55.2813ZM38.812 50.4726C38.3819 50.936 38.0951 51.4864 37.8657 52.0658C38.1238 51.5154 38.4106 50.965 38.812 50.4726ZM37.9231 53.6011C37.5216 53.1666 37.7224 52.79 37.6937 52.5583C37.6554 52.7128 37.6172 52.8769 37.579 53.0507C37.7224 53.4563 37.751 53.6301 37.9231 53.6011Z",
    fill: "#38C1ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_3557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/LogoMain.29feb01e8f3423ca1575e6f11203e2f9.svg";
export { ForwardRef as ReactComponent };